import React from 'react'
import SettingSeoForm from '../components/setting/settingsUzantiForm'

const SettingsUzanti = () => {
    return (
        <>
            <SettingSeoForm />
        </>
    )
}

export default SettingsUzanti